if (!customElements.get('recently-viewed')) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.enableSlider = this.dataset.enableSlider;
    }

    initSwiperSlider() {
      let btnNext = this.querySelector('.swiper-button-next');
      let btnPrev = this.querySelector('.swiper-button-prev');
      this.swiperSlider = new Swiper(this, {
        slidesPerView: 'auto',
        navigation: {
          nextEl: btnNext,
          prevEl: btnPrev,
        },
      });
    }
    connectedCallback() {
      const handleIntersection = async (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        const response = await fetch(`${this.dataset.url}&q=${this.getSearchQuery()}`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const el = tmpl.content.querySelector('recently-viewed');
        if (el && el.hasChildNodes()) {
          this.innerHTML = el.innerHTML;
        }

        const items = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');
        for (let i = 0; i < items.length; i++) {
          if (this.querySelector(`li[data-id="${items[i]}"]`)) {
            this.querySelector(`li[data-id="${items[i]}"]`).style.order = (i + 1);
          }
        }

        if (this.enableSlider === "true") {
          this.initSwiperSlider();
        }

        // Swym wishlist: re-init action buttons after recently viewed render
        if (window._swat && typeof _swat.initializeActionButtons === 'function') {
          _swat.initializeActionButtons('body');
        }

        if (window.initButtonHoverEffects && typeof window.initButtonHoverEffects === 'function') {
          window.initButtonHoverEffects();
        }
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }

    getSearchQuery() {
      const items = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');
      return items
        .slice(1)
        .map((item) => `id:${item}`)
        .slice(0, this.dataset.limit)
        .join(' OR ');
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);
}
